
import { defineComponent, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useUserInfoStore } from "./stores/UserInfoStore";
import { usePaginatorSetup } from "@/stores/PaginatorStore";
import API from "@/apis/TPSAPI";
import { APIResultCode } from "@/models/enums/APIResultCode";

export default defineComponent({
  setup() {
    const router = useRouter();
    const userInfoStore = useUserInfoStore();
    const paginatorSetup = usePaginatorSetup();

    //註冊resize事件
    window.addEventListener("resize", onResized);

    onMounted(async () => {
      console.log(`App onMounted`);

      //設置分頁RWD
      paginatorSetup.update(window.innerWidth);
      
    });

    /** Resize事件 (全域) */
    function onResized() {
      paginatorSetup.update(window.innerWidth);
    }

    return {
      userInfoStore,
    };
  },
});
